import { ComponentType, PropsWithChildren } from 'react'
import Styles from './ExportButtons.module.scss'
import { DownloadImage } from 'blaze-ui/icons/36'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import Review from 'blaze-ui/icons/32/Review'
import { DesignDownloadDrawer } from 'components/DesignDownloadModal/DesignDownloadDrawer'
import cx from 'classnames'
import { forwardRef } from 'react'
import { useObjectRef } from '@react-aria/utils'
import { useButton } from '@react-aria/button'
import { useHover } from '@react-aria/interactions'
import { ShareSheetDrawer } from 'common/ShareSheetV2/Drawer/ShareSheetDrawer'

interface ExportButtonProps extends PropsWithChildren<{}> {
  icon: ComponentType<{}>
  onPress: () => void
}

export const ExportButton = forwardRef<HTMLDivElement, ExportButtonProps>(({ icon: Icon, onPress, children }, fRef) => {
  const ref = useObjectRef(fRef)
  const { buttonProps, isPressed } = useButton({ onPress, elementType: 'div' }, ref)
  const { hoverProps, isHovered } = useHover({})

  return (
    <div
      {...buttonProps}
      {...hoverProps}
      className={cx(Styles.exportButton, {
        [Styles.hovered]: isHovered,
        [Styles.pressed]: isPressed,
      })}
      ref={ref}
    >
      <Icon />
      <div className={Styles.label}>{children}</div>
    </div>
  )
})

export const ExportButtons = observer(() => {
  const { drawersStore, designStore } = useRootStore()

  const file = designStore?.file

  if (!file) return null

  const openDownloadDrawer = () => {
    drawersStore.openDrawer(DesignDownloadDrawer)
  }

  const openShareDrawer = () => {
    drawersStore.openDrawer(ShareSheetDrawer, {
      file: {
        id: file.id,
        type: 'design',
      },
    })
  }

  return (
    <div className={Styles.exportButtonsContainer}>
      <div className={Styles.exportButtonsHorizontalContainer}>
        <ExportButton icon={() => <DownloadImage size={20} />} onPress={openDownloadDrawer}>
          Save to Camera Roll
        </ExportButton>
        <ExportButton icon={() => <Review size={20} />} onPress={openShareDrawer}>
          Share for Review
        </ExportButton>
      </div>
    </div>
  )
})
